import { NodeInterface } from "@swivl-mono/types";
import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import { RandomId } from "@swivl-mono/helpers";



const SpacePicker = {
  Type: "spacePicker",
  Empty: function() {
          let node = {
              "id": RandomId(6),
              "type": SpacePicker.Type,
              "selectedGoto":"",
              "locationCodeVariableId":"LocationId",
              "notSelectedGoto":"",
              "searchDifferentStoreGoto":"",
              "noUnitsGoto":""

            }
        return node; //

    },
    PlumbData: function(node:NodeInterface) {


      const tabs = [{
         "id": "selectedGoto",
         "source": "selectedGoto",
         "target": node.selectedGoto,
         "title": "Unit Selected",
       },
       {
          "id": "notSelectedGoto",
          "source": "notSelectedGoto",
          "target": node.notSelectedGoto,
          "title": "No Unit Selected",
        },
        {
          "id": "noUnitsGoto",
          "source": "noUnitsGoto",
          "target": node.noUnitsGoto,
          "title": "No Units Available",
        },
        {
          "id": "searchDifferentStoreGoto",
          "source": "searchDifferentStoreGoto",
          "target": node.searchDifferentStoreGoto,
          "title": "Search Different Store",
        }
     ]

     return TabNodeLayoutData({
      node: node,
      title:"Get Store Units",
      body:node.text || "",
      baseWidth: 170,
      tabs:tabs
    });
   },
   InspectorPanel: class InputInspectorPanel extends NodePanel{

    

    

    

    render() {

        return (<div>
              <div className="panel message_panel">
                <InspectorNodeHeader title="Get Store Units" />
                <label>Store Location Code</label>
                <UserVariablesDropdown
                  onChange={this.onChange}
                  skipUserId={true}
                  name={"locationCodeVariableId"}
                  value={this.props.node.locationCodeVariableId}
                />

              </div>
              <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
            </div>);

     }
   }
}
export default SpacePicker;
